import request from "../request.js";
//创建用户接口
export function register(data) {
  // console.log(data);
  return request({
    url: "/api/v1/register",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

//获取用户信息
export function sys_user_me() {
  // console.log(data);
  return request({
    url: "/api/v1/user/user_info",
    headers: { "content-type": "application/json" },
    method: "post"
  });
}

//用户昵称修改
export function nickname_change(data) {
  // console.log(data);
  return request({
    url: "/api/v1/user/nickname_change",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

//用户密码修改
export function fgt_pwd_change(data) {
  // console.log(data);
  return request({
    url: "/api/v1/user/fgt_pwd_change",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

//用户密码修改
export function pwd_change(data) {
  // console.log(data);
  return request({
    url: "/api/v1/user/pwd_change",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

// 产品列表查询 product_list
export function product_list(data) {
  // console.log(data);
  return request({
    url: "/api/v1/product/product_list",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

// 产品价格查询 product_price
export function product_price(data) {
  // console.log(data);
  return request({
    url: "/api/v1/product/product_price",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

//购买记录查询
export function soft_list(data) {
  // console.log(data);
  return request({
    url: "/api/v1/product/soft_list",
    headers: { "content-type": "application/json" },
    method: "get"
  });
}

//购买记录查询
export function product_buy_list(data) {
  // console.log(data);
  return request({
    url: "/api/v1/product/product_buy_list",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

//购买记录查询
export function product_refund(data) {
  // console.log(data);
  return request({
    url: "/api/v1/product/refund",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}


// 刷新token
export function refresh_token(data) {
  // console.log(data);
  return request({
    url: "/api/v1/refresh-token",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

// send_register_sms
export function send_register_sms(data) {
  // console.log(data);
  return request({
    url: "/api/v1/sms/send_register_sms",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}


// send_reset_pwd_sms
export function send_reset_pwd_sms(data) {
  // console.log(data);
  return request({
    url: "/api/v1/sms/send_reset_pwd_sms",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

// send_reset_pwd_sms
export function sms_check(data) {
  // console.log(data);
  return request({
    url: "/api/v1/sms/sms_check",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}


//获取支付结果信息
export function wx_zf_re(data) {
  // console.log(data);
  return request({
    // url: "http://payapi.yogoo.net/wxzf/result/T2024126163137.json",
    url: data,
    headers: { "content-type": "application/json" },
    method: "get"
  });
}

//创建订单接口
export function order_bill_create(data) {
  // console.log(data);
  return request({
    url: "/api/v1/product/create_product_order",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}


//获取订单接口
export function order_bill(data) {
  console.log("==order_bill=",data);
  return request({
    // url: "/api/v1/order_bill?page=1&size=1000",
    url: "/api/v1/order_bill/",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

//申请开票接口
export function update_receipt_info(data) {
  // console.log(data);
  return request({
    url: "/api/v1/product/update_receipt_info",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

//请求账号激活的token，并发送激活邮件
export function sys_acount_request_verify_token(data) {
  // console.log(data);
  return request({
    url: "/api/v1/acount/request_verify_token",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

//邮箱token验证
export function sys_acount_verify(data) {
  // console.log(data);
  return request({
    url: "/api/v1/acount/verify",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

// 价格查询
export function sys_app_get_price(data) {
  // console.log(data);
  return request({
    url: "/api/v1/sys_app/get_price",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}

// 邀请码验证
export function validate_invite_code(data) {
  // console.log(data);
  return request({
    url: "/api/v1/validate-invite-code",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}